module.exports = __webpack_public_path__ + "static/img/a10.542635f4.jpg";